import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import vuetify from "./plugins/vuetify";
import Vuelidate from "vuelidate";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import AOS from "aos";
import "animate.css";
import VueAnimated from "@asika32764/vue-animate";
import "aos/dist/aos.css";
import VueSSE from "vue-sse";
import VueLottiePlayer from "vue-lottie-player";
import i18n from "./i18n";
import errorHandler from "./plugins/errorHandler";
import { setupAxiosInterceptors } from "./plugins/axios.interceptor";

// Importer api.service pour initialiser automatiquement les intercepteurs Axios
import "@/services/api.service";

// Configurer les intercepteurs Axios globaux pour le refresh token
setupAxiosInterceptors();

Vue.config.productionTip = false;
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(VueAnimated);
Vue.use(VueSSE);
Vue.use(VueLottiePlayer);
Vue.use(errorHandler);

// Les intercepteurs Axios sont maintenant configurés automatiquement dans api.service.js

new Vue({
  router,
  store,
  vuetify,
  i18n,
  mounted() {
    AOS.init();
  },
  render: (h) => h(App),
}).$mount("#app");
